import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from '@mono/ui-components';
import { Check, Loader2, Search, Sparkles } from 'lucide-react';
function parseResult(result) {
    try {
        return JSON.parse(result);
    } catch  {
        return null;
    }
}
/**
 * Beautiful card for displaying discover_tools results
 */ export function DiscoverToolsCard({ toolCall }) {
    const isComplete = !!toolCall.result;
    const hasError = !!toolCall.error;
    const parsed = toolCall.result ? parseResult(toolCall.result) : null;
    if (hasError) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center gap-2 px-3 py-2 text-sm text-red-500 bg-red-500/5 border border-red-500/20 rounded-lg",
            children: [
                /*#__PURE__*/ _jsx(Search, {
                    className: "h-4 w-4"
                }),
                /*#__PURE__*/ _jsxs("span", {
                    children: [
                        "Tool discovery failed: ",
                        toolCall.error
                    ]
                })
            ]
        });
    }
    if (!isComplete) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center gap-2 px-3 py-2 text-sm text-muted-foreground bg-muted/30 border rounded-lg",
            children: [
                /*#__PURE__*/ _jsx(Loader2, {
                    className: "h-4 w-4 animate-spin text-muted-foreground"
                }),
                /*#__PURE__*/ _jsx("span", {
                    children: "Searching for tools..."
                })
            ]
        });
    }
    if (!parsed || parsed.count === 0 || !parsed.results || !Array.isArray(parsed.results)) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "flex items-center gap-2 px-3 py-2 text-sm text-muted-foreground bg-muted/30 border rounded-lg",
            children: [
                /*#__PURE__*/ _jsx(Search, {
                    className: "h-4 w-4"
                }),
                /*#__PURE__*/ _jsxs("span", {
                    children: [
                        'No tools found for "',
                        parsed?.query || 'query',
                        '"'
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "border rounded-lg overflow-hidden bg-muted/20",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between px-3 py-2 bg-muted/30 border-b",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "p-1.5 rounded-md bg-muted",
                                children: /*#__PURE__*/ _jsx(Search, {
                                    className: "h-4 w-4 text-foreground"
                                })
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-sm font-medium",
                                children: "Tool Discovery"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsxs(Badge, {
                                variant: "secondary",
                                className: "text-xs",
                                children: [
                                    parsed.count,
                                    " found"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Check, {
                                className: "h-4 w-4 text-green-500"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "p-2 space-y-2",
                children: parsed.results.map((tool, idx)=>/*#__PURE__*/ _jsxs("div", {
                        className: "flex items-start gap-3 p-2 rounded-md bg-background/50 hover:bg-background/80 transition-colors",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "p-1.5 rounded-md bg-primary/10 mt-0.5",
                                children: /*#__PURE__*/ _jsx(Sparkles, {
                                    className: "h-3.5 w-3.5 text-primary"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex-1 min-w-0",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center gap-2 mb-0.5",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "text-sm font-medium",
                                                children: tool.name
                                            }),
                                            /*#__PURE__*/ _jsx(Badge, {
                                                variant: "outline",
                                                className: "text-[10px] px-1.5 py-0",
                                                children: tool.category
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "text-xs text-muted-foreground line-clamp-2",
                                        children: tool.description
                                    })
                                ]
                            })
                        ]
                    }, idx))
            })
        ]
    });
}
